import { render, staticRenderFns } from "./BranchSalesChart.vue?vue&type=template&id=30b1e2f8"
import script from "./BranchSalesChart.vue?vue&type=script&lang=js"
export * from "./BranchSalesChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports